<!--
트래킹검수 > 푸터
------------------------------------
-->
<template>
    <div class="footer-bar uk-flex uk-flex-between uk-flex-bottom">

        <div class="uk-margin-right">
            <a @click="moveMain" class="link" title="지역 > 메인으로 이동">
                <i class="material-icons uk-text-middle">home</i>
                MAIN
            </a>
        </div>
        <div class="uk-margin-right">
            <a @click="moveShipInScan" class="link" title="입고스캔으로 이동">
                <i class="material-icons uk-text-middle">aspect_ratio</i>
                입고스캔
            </a>
        </div>
        <div class="uk-margin-right">
            <a @click="moveNodataScan" class="link" title="무자료확인으로 이동">
                <i class="material-icons uk-text-middle">aspect_ratio</i>
                무자료확인
            </a>
        </div>
        <div class="uk-margin-right">
            <a @click="moveTrackingCheck" class="link" title="입고스캔으로 이동">
                <i class="material-icons uk-text-middle">aspect_ratio</i>
                트래킹검수
            </a>
        </div>

        <div class="uk-width-expand">
        </div>

        <div class="screen-ratio">
            <!-- 검수 화면배율 -->
            <a class="zoom-out" @click="screenRatioZoomOut" :disabled="screenRatioZoomOutDisabled">
                <i class="material-icons">remove</i>
            </a>
            <div class="title">
                화면배율 {{ screenRatioText }}
            </div>
            <a class="zoom-in" @click="screenRatioZoomIn" :disabled="screenRatioZoomInDisabled">
                <i class="material-icons">add</i>
            </a>

        </div>

        <div class="uk-margin-right">
            <!-- 검수 레이아웃 선택 -->
            <p-radio
                v-for="(text, mode) in checkModeOptions"
                :key="mode"
                class="p-default p-curve"
                name="radio-check-mode"
                color="success"
                :value="mode"
                :checked="checkMode === mode"
                v-on:change="$emit('update:checkmode', $event)"
            >
                <i slot="extra" class="icon mdi mdi-check"></i>
                {{ text }}
            </p-radio>
        </div>


        <div class="">
            <i class="material-icons uk-text-middle">person</i>
            작업자 : {{ loginUserName }}
        </div>

    </div>
</template>

<script>


import screenRatioAble from "../../common/screen-ratio-able.vue";

export default {
    mixins: [
        screenRatioAble,
    ],
    props: {
        /**
         * 지역id
         */
        regionId: {
            type: Number,
            default: null,
        },

        /**
         * 사용자명
         */
        loginUserName: {
            type: String,
            default: null,
        },

        /**
         * 검수모드
         */
        checkMode: {
            type: String,
        },




    },
    data: function () {
        return {
            checkModeOptions: {
                normal: '일반',
                //new: '신규',

                //oldNormal: '(미사용)일반',
                //batch: '(미사용)일괄',
            },

        };
    },
    computed: {



    },
    mounted() {
//        console.log('mounted on component');

    },
    methods: {
        /**
         * 메인으로 이동
         */
        moveMain: function () {
            $.app.move('/regions/' + this.regionId);
        },

        /**
         * 입고스캔 이동
         */
        moveShipInScan: function () {
            $.app.move('/regions/' + this.regionId + '/ship-ins/scan');
        },

        /**
         * 무자료확인 이동
         */
        moveNodataScan: function () {
            $.app.move('/regions/' + this.regionId + '/nodata-scan');
        },

        /**
         * 트래킹검수 이동
         */
        moveTrackingCheck: function () {
            $.app.move('/regions/' + this.regionId + '/tracking-check');
        },

    },
}
</script>

<style lang="scss" scoped>
.footer-bar {
    border: 0;
    padding: 10px;
    background-color: #1F2B3D !important;
    color: #fff;
    font-size: 1rem;

    .material-icons {
        vertical-align: middle;
        font-size: 1.5rem;
    }


    a.link, a.link:visited {
        font-size: 1rem;
        color: #fff;
    }

    // 화면배율
    .screen-ratio{
        margin-right: 1rem;
        display: flex;

        .title, .zoom-in, .zoom-out {
            background-color : transparent;
            color: #fff;
            padding: 0 1rem;
            border: 1px solid #fff;

        }

        .zoom-in, .zoom-out {
            cursor: pointer;
            padding: 0 0.25rem;

            &.zoom-out {
                border-radius: 30px 0 0 30px;
                border-right: 0;
            }
            &.zoom-in {
                border-radius: 0 30px 30px 0;
                border-left: 0;
            }

            &[disabled] {
                cursor: unset;
                color: #999;
                border: 1px solid #999;
            }


            &:hover:not([disabled]) {
                background-color : #fff;
                color: #000;
            }
        }


    }

}
</style>